<template>
    <div class="p-30 pt-10" v-loading="loading">

        <div class="flex jc-sb mb-40">
            <div class="w-150">
                <el-button size="small" @click="back">返回</el-button>
            </div>
            <div style="width: 600px;">
                <el-steps :active="addStep" align-center>
                    <el-step title="设置班级基本信息"></el-step>
                    <el-step title="添加学生"></el-step>
                </el-steps>
            </div>

            <div class="w-150 flex jc-fe">
                <el-button v-if="addStep == 1" size="small" type="primary" @click="next">下一步</el-button>

                <el-link v-if="addStep == 2" type="primary mr-20" @click="confirm('pass')">跳过</el-link>
                <el-button v-if="addStep == 2" size="small" type="primary" @click="confirm('add')">完成</el-button>
            </div>
        </div>

        <div class="flex" v-if="addStep == 1">
            <el-form :model="classForm" style="width: 400px;" label-width="50px">
                <el-form-item label="班级类型：">
                    <el-select v-model="classForm.classType" placeholder="请选择类型">
                        <el-option v-for="item in classTypeOpt" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="年级：">
                    <el-cascader v-model="classForm.gradeId" :options="gradeOpt"
                        :props="{ expandTrigger: 'hover' }"></el-cascader>
                </el-form-item>
                <el-form-item label="班级名称：">
                    <el-input v-model="classForm.className" placeholder="请输入班级名称"></el-input>
                </el-form-item>
                <el-form-item label="设置班主任：">
                    <div class="flex">
                        <el-input class="mr-20" v-model="classForm.userTel" placeholder="请输入班主任电话"></el-input>
                        <div>
                            需要注册移动端
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="班级人数上限：">
                    <el-input-number v-model="classForm.maxSize" :min="1" :max="300"></el-input-number>
                </el-form-item>
            </el-form>
        </div>

        <div class="flex" v-if="addStep == 2">
            <div>
                <div class="t-c mb-15">只可导入已在移动端注册过的学生信息</div>
                <div class="mb-15">
                    <el-button type="primary" plain icon="el-icon-download">下载模版</el-button>
                </div>
                <el-upload action="#" :on-change="parseExcel" :before-remove="delExcel" :auto-upload="false" :limit="1"
                    drag>
                    <div v-if="!filUrl">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将excel拖到此处，或<em>点击添加excel</em></div>
                    </div>
                    <!-- <div v-else class="image-container">
                        <img :src="filUrl" alt="">
                    </div> -->
                </el-upload>
            </div>
        </div>


        <div class="flex fd-c f-16" v-if="addStep == 3">
            <div class="card-box pt-40 pb-40 mb-40">
                <img class="img-64 mb-20" src="@/assets/img/class/complete.png" alt="">
                <div class="c-303133">班级创建成功！</div>
            </div>
            <div class="card-box pt-40 pb-40 mb-40 pl-40 pr-20 flex jc-sb">
                <div class="c-9e9e9e">一键邀请【班级名称】班级成员加入</div>
                <div>
                    <el-button plain>班群号邀请</el-button>
                    <el-button plain>二维码邀请</el-button>
                </div>
            </div>
            <div class="card-box pt-20 pb-20 mb-40 pl-40 pr-20 flex jc-sb">
                <div class="c-9e9e9e">是否创建家长同步班级（自动创建家长同步班级）</div>

                <el-button plain>创建</el-button>
            </div>
        </div>


    </div>
</template>

<script>
import { queryGrade, checkTeacher, createClass } from '@/api/index2';
import { encrypt, decrypt } from '@/api/common_encrypt';

import XLSX from 'xlsx';


export default {
    name: 'addClass',
    components: {},
    computed: {

    },
    data() {
        return {
            loading: false,

            addStep: 1,
            // addStep: 2,

            classForm: {
                classType: 1,
                gradeId: "",
                className: "",
                userTel: "",
                maxSize: 300,
            },
            admin: {},
            classInfo: {},

            parsedData: [],
            filUrl: "",

            classTypeOpt: [
                {
                    value: 1,
                    label: '学生班'
                },
                {
                    value: 2,
                    label: '教师班'
                },
                {
                    value: 3,
                    label: '家长班'
                },
            ],

            gradeOpt: [
                {
                    value: 'p1',
                    label: '幼儿',
                    children: []
                },
                {
                    value: 'p2',
                    label: '小学',
                    children: []
                },
                {
                    value: 'p3',
                    label: '中学',
                    children: []
                },
                {
                    value: 'p4',
                    label: '大学',
                    children: []
                },
            ]
        };
    },
    mounted() {
        this.queryGrade();
    },

    methods: {
        back() {
            if (this.addStep == 2) {
                this.addStep = 1;
            } else {
                this.$router.go(-1);
            }
        },
        queryGrade() {
            console.log('111 :>> ', 111);
            queryGrade().then((res) => {
                if (res.result == 1) {
                    console.log('res :>> ', res.data);
                    res.data.forEach((g) => {
                        this.gradeOpt.forEach((p) => {
                            if (p.value == `p${g.period}`) {
                                p.children.push({
                                    value: g.gradeId,
                                    label: g.gradeName
                                });
                            }
                        });
                    });

                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        parseExcel(file) {
            // // 检查文件类型
            // const isExcel = file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            // if (!isExcel) {
            //     this.$message.error('请上传Excel文件');
            //     return
            // }
            // // 检查文件大小
            // const isLt2M = file.size / 1024 / 1024 < 2;
            // if (!isLt2M) {
            //     this.$message.error('上传文件大小不能超过2MB');
            //     return
            // }
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                let xArr = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                xArr.shift();
                for (let row of xArr) {
                    let obj = {
                        userClassNickname: row[0],
                        userClassNumber: row[1],
                        userClassTel: row[2]
                    };
                    this.parsedData.push(obj);
                }
            };
            reader.readAsArrayBuffer(file.raw);
        },
        delExcel() {
            this.parsedData = [];
        },
        next() {
            if (!this.classForm.classType || !this.classForm.gradeId || !this.classForm.className || !this.classForm.userTel) {
                this.$message({
                    showClose: true,
                    message: '请完善信息',
                    type: 'warning'
                });
                return;
            } else {
                this.loading = true;
                let param = {
                    userTel: this.classForm.userTel,
                };
                checkTeacher(param).then((res) => {
                    if (res.result == 1) {
                        this.admin = {
                            userId: res.data.userId,
                            userNickname: res.data.userNickname,
                            userTel: res.data.userTel,
                        }
                        this.addStep++;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        });
                    }
                    this.loading = false;
                });

            }
        },
        confirm(msg) {
            console.log(msg, this.parsedData);
            let param = {
                classType: this.classForm.classType,
                gradeId: this.classForm.gradeId[1],
                className: this.classForm.className,
                maxSize: this.classForm.maxSize,
                userClassMemberList: [],
                admin: this.admin,
            }
            if (msg == "add") {
                if (this.parsedData.length == 0) {
                    this.$message({
                        showClose: true,
                        message: '请导入学生信息',
                        type: 'warning'
                    });
                    return
                }
                param.userClassMemberList = this.parsedData;
            }
            // console.log('param :>> ', param);
            // return;
            createClass(param).then((res) => {
                console.log('res :>> ', res);
                if (res.result == 1) {
                    this.classInfo = res.data;
                    this.addStep++;
                    console.log('this.classInfo :>> ', this.classInfo);
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });

        }
    },
};
</script>

<style lang='scss' scoped>
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
    margin-bottom: 40px;
}

.class-card {
    border-radius: 20px;
    border: 1px solid #ebeef5;
    transition: box-shadow 0.3s ease, transform 0.3s ease;
}

.class-card:hover {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.15);
    // transform: translateY(-1px);
}

.line-h {
    display: inline-block;
    height: 1px;
    width: 100%;
    background-color: #d8d8d8;
}

.card-box {
    width: 570px;
    border-radius: 20px;
    text-align: center;
    border: 1px solid #606266;
    margin-bottom: 40px;
}
</style>
